/**
 * Hetzner API Client fuer Online-Anamnese
 *
 * Ersetzt Firebase — alle Calls gehen an die Hetzner FastAPI
 */

const API_BASE = process.env.REACT_APP_API_URL || 'https://lisa-api.dr-hezel.de/api';

/**
 * Token validieren und Patienten-Daten + Public Key laden
 * GET /api/anamnese/token/{token}
 */
export async function validateToken(token) {
  const response = await fetch(`${API_BASE}/anamnese/token/${token}`);

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    if (response.status === 409) {
      throw new TokenError(data.detail || 'Bereits ausgefuellt', 'submitted');
    }
    if (response.status === 410) {
      // 410 Gone = abgelaufen oder widerrufen
      const reason = (data.detail || '').includes('abgelaufen') ? 'expired' : 'revoked';
      throw new TokenError(data.detail || 'Link nicht mehr gueltig', reason);
    }
    if (response.status === 404) {
      throw new TokenError(data.detail || 'Ungueltiger Link', 'invalid');
    }
    throw new Error('Serverfehler bei Token-Validierung');
  }

  return response.json();
}

/**
 * Verschluesselte Anamnese absenden
 * POST /api/anamnese/submit
 * @param {Object} payload - { token, encrypted_data, encrypted_key, iv, key_version }
 */
export async function submitAnamnese(payload) {
  const response = await fetch(`${API_BASE}/anamnese/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      token: payload.token,
      encrypted_data: payload.encrypted_data,
      encrypted_key: payload.encrypted_key,
      iv: payload.iv,
      key_version: payload.key_version
    })
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || 'Fehler beim Absenden');
  }

  return response.json();
}

/**
 * Entwurf speichern (UPSERT)
 * PUT /api/anamnese/draft/{token}
 * @param {string} token
 * @param {Object} encrypted - { encrypted_data, encrypted_key, iv, key_version }
 */
export async function saveDraft(token, encrypted) {
  const response = await fetch(`${API_BASE}/anamnese/draft/${token}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      encrypted_data: encrypted.encrypted_data,
      encrypted_key: encrypted.encrypted_key,
      iv: encrypted.iv,
      key_version: encrypted.key_version
    })
  });

  if (!response.ok) {
    console.warn('Draft-Speichern fehlgeschlagen:', response.status);
    return null;
  }

  return response.json();
}

/**
 * Entwurf laden
 * GET /api/anamnese/draft/{token}
 */
export async function loadDraft(token) {
  const response = await fetch(`${API_BASE}/anamnese/draft/${token}`);

  if (response.status === 404) {
    return null; // Kein Draft vorhanden
  }

  if (!response.ok) {
    console.warn('Draft-Laden fehlgeschlagen:', response.status);
    return null;
  }

  return response.json();
}

/**
 * Custom Error-Klasse fuer Token-Fehler
 */
export class TokenError extends Error {
  constructor(message, reason) {
    super(message);
    this.reason = reason;
    this.name = 'TokenError';
  }
}
